import axios from "axios";

export default function AddUser(props){
    
    function submitHandler(e){
       
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.post(`${process.env.REACT_APP_BASE_URL}api/user/open/createUser`,data)
        .then(result=>{alert("Create Successfully!");window.location.href="/login"})
        .catch(err=>alert(err.response.data));
    }

    return(<div className="small-form-container container">
        <div className="text-center">
            <h2>Create User</h2>
        </div><hr />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                    <div>
                        <input className="form-control" type="text" name="fullname" placeholder="Fullname" required />
                    </div>
                    <div>
                        <input className="form-control" type="text" name="email" placeholder="Email" required />
                    </div>
                    <div>
                        <input className="form-control" type="text" name="mobile" placeholder="Mobile" />
                    </div>
                    <div>
                        <input className="form-control" type="text" name="password" placeholder="Password" required />
                    </div>
                    <div>
                        <button className="btn btn-color form-control">Submit</button>
                    </div> 
                </div> 
                 <br />
                <div className="text-center">
                    <a href="/" className="text-decoration-none text-muted">
                    &larr; Return to Home
                    </a>
                </div>
            </form>
        </div>
    </div>);
}